export default {
  'site.name': '黄本子官方指南',
  'site.tagline': '最权威、最详尽的黄本子专题落地页',
  'nav.home': '首页',
  'nav.category': '分类',
  'nav.about': '关于我们',
  'nav.contact': '联系我们',
  'hero.title': '黄本子官方指南',
  'hero.subtitle': '你最需要了解的完整解析',
  'hero.badge': '最权威的黄本子专题指南',
  'hero.description': '全面解析黄本子的定义、用途、获取方式及注意事项，帮助每一位用户快速了解黄本子的核心价值，掌握正确使用方法，避免常见误区。',
  'hero.cta_start': '开始了解',
  'hero.cta_faq': '常见问题',
  'category.title': '按主题浏览',
  'category.subtitle': '我们已将黄本子的相关知识按主题精心分类，方便您快速找到所需内容',
  'articles.featured': '精选内容',
  'articles.recommended': '推荐阅读',
  'articles.latest': '最新发布',
  'articles.newest': '最新文章',
  'articles.viewAll': '查看全部',
  'faq.title': '热门问答',
  'faq.subtitle': '这里汇总了关于黄本子最常被问到的问题，帮您快速找到答案',
  'cta.title': '还有疑问？联系我们',
  'cta.subtitle': '我们的团队随时准备为您解答关于黄本子的任何疑问，提供专业、及时的指导服务',
  'cta.learn_more': '了解更多',
  'footer.copyright': '保留所有权利',
  'footer.disclaimer': '本站内容仅供参考，具体以官方发布为准',
};